// extracted by mini-css-extract-plugin
export default {"main":"Home_main__HT6V3","content":"Home_content__gBsDR","overlay":"Home_overlay__N5zUb"};